// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"155":"966a9474","201":"182e5c96","225":"66d9c7d2"}[chunkId] + ".chunk.js");